document.addEventListener("DOMContentLoaded", function () {
  $('.slider1').attr('dir', 'rtl');
  $(".slider1").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    rtl: true,
    variableWidth: true
  });

  $(".slider2").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    variableWidth: true
  });

  $(".mainvisual-flex--lists").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    cssEase: "linear",
    infinite: true,
    autoplaySpeed: 3000,
    speed: 600,
  });

  // 初期化
  const grid = document.querySelector('.grid');
  new Masonry(grid, {
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    gutter: 68,
    percentPosition: true,
    horizontalOrder: true

  });

  $('a[href^="#"]').on('click', function(e) {
    e.preventDefault(); // デフォルトのリンク動作をキャンセル

    var speed = 800; // ミリ秒（スクロール速度）
    var href = $(this).attr('href');
    var $target = $(href === "#" || href === "" ? 'html' : href);
    var position = $target.offset().top - 110;

    $('html, body').animate({ scrollTop: position }, speed, 'swing');
  });

  function fadeInOnScroll() {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var delay = 0;

    $('.fade-item').each(function(i) {
      var $this = $(this);
      var elemPos = $this.offset().top;

      if (!$this.hasClass('show') && scroll + windowHeight > elemPos + 50) {
        // 順番に遅延（100ms 間隔など）
        setTimeout(function() {
          $this.addClass('show');
        }, delay);
        delay += 100; // 次の要素は100ms後に実行
      }
    });
  }

  $(function() {
    // 初回とスクロールごとに判定
    fadeInOnScroll();
    $(window).on('scroll', fadeInOnScroll);
  });

  new Rellax('.rellax');

});
